import React from 'react';
import { useTheme } from 'styled-components';
import PropTypes from 'prop-types';

import { Box, Text as BaseText } from 'Components/Base';

import { TextSubTitle, TextDescription } from '../Components/TextContent';
import { ContentWrapper, CardWrapper } from '../Components/WrapperContent';

const Text = (props) => <BaseText ml={2} as="span" {...props} />;

const ByteArkStatus = ({ data, loading }) => {
  const { colors } = useTheme();
  const { ip, asnum, isp, geo, node } = data ?? {};

  const regionNames = new Intl.DisplayNames(['en'], { type: 'region' });
  const region = regionNames.of(geo?.country ?? 'TH');
  const country = geo ? `${region} (${geo?.country})` : '-';
  const ipsCode = isp ? `${geo?.continent}${asnum} ${isp}` : '-';
  const ipAddress = ip ?? '-';
  const cdnServer = node ?? '-';

  return (
    <>
      <ContentWrapper gridTemplateColumns={'auto 1fr'} gridGap={0}>
        <Box
          px="2px"
          style={{
            background: loading ? colors?.bsGrays.gray300 : colors?.primary,
            borderRadius: '6px 0px 0px 6px',
          }}
        />
        <CardWrapper>
          <TextSubTitle mb={2}>ByteArk</TextSubTitle>
          <TextDescription>
            IP Address:<Text>{loading ? '-' : ipAddress}</Text>
          </TextDescription>
          <TextDescription>
            ISP Code:<Text>{loading ? '-' : ipsCode}</Text>
          </TextDescription>
          <TextDescription>
            Country:<Text>{loading ? '-' : country}</Text>
          </TextDescription>
          <TextDescription>
            CDN Server:<Text>{loading ? '-' : cdnServer}</Text>
          </TextDescription>
        </CardWrapper>
      </ContentWrapper>
    </>
  );
};

ByteArkStatus.propTypes = {
  data: PropTypes.object,
  loading: PropTypes.bool,
};

export default ByteArkStatus;
